import { Marker } from '@/types.d';
import { CompassContextType } from '@/src/libs/CompassContext';

import { sortMarkersByDistanceFromCenter } from './sortMarkersByDistanceFromCenter';

export const sortAndCenterNewMarkers = (
  markers: Marker[],
  ctx: CompassContextType
) => {
  if (!markers.length) return [];
  if (!ctx) throw new Error('No context provided');
  if (!ctx.state?.map) throw new Error('No map found in context');

  const center = ctx.state.map.getCenter();

  if (!center) return markers;

  return sortMarkersByDistanceFromCenter(
    { lat: center.lat(), lng: center.lng() },
    markers
  );
};
